import React, {Component} from 'react';

import { dt } from 'l10n';

class HeaderNotification extends Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    changeSite() {
        const { name, settings } = this.props;

        const site = settings.site ? 0 : 1;
        const newSettings = {...settings, site};

        this.props.changeSettings(name, newSettings);
    }

    changeEmail() {
        const { name, settings } = this.props;

        const email = settings.email ? 0 : 1;
        const newSettings = {...settings, email};

        this.props.changeSettings(name, newSettings);
    }

    render() {
        const {
            site,
            email,
        } = this.props.settings;

        const { 
            id,
            title
        } = this.props;

        return (
            <div className="item-block">
                <div className="item-title">{dt('notifications', title)}</div>
                <div className="checkbox">
                    <input type="checkbox" id={`site-${id}`} defaultChecked={site ? 'checked' : ''}/>
                    <label htmlFor={`site-${id}`} onClick={() => this.changeSite()}>{dt('notifications','Notify me on site')}</label>
                </div>
                {email !== -1 && (
                    <div className="checkbox">
                        <input type="checkbox" id={`email-${id}`} defaultChecked={email ? 'checked' : ''}/>
                        <label htmlFor={`email-${id}`} onClick={() => this.changeEmail()}>{dt('notifications','Notify me by email')}</label>
                    </div>
                )}
            </div>
        )
    }
}

export default HeaderNotification;


// WEBPACK FOOTER //
// ./src/components/notification/ItemSettingCheckBlock.js